// Envision - create YouTube video elements on click for image-text section 
$(function() {
  if ($('.alt-img-with-text--container .video-element[data-id]').length) {
    $('.alt-img-with-text--container .video-element[data-id]').on('click', function() {
      if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
        var videoID = false;
        var videoPlayerElementID = false;

        videoID = $(this).data('id');
        videoPlayerElementID = $(this).find('.video-iframe').attr('id');

        if (videoID && videoPlayerElementID) {
          var player = new YT.Player(videoPlayerElementID, {
            videoId: videoID,
            width: 560,             // Player width (in px)
            height: 316,            // Player height (in px)
            playerVars: {
              autoplay: 1,          // Auto-play the video on load
              controls: 1,          // Show pause/play buttons in player
              showinfo: 0,          // Hide the video title
              modestbranding: 1,    // Hide the Youtube Logo
              loop: 0,              // Run the video in a loop
              fs: 1,                // Hide the full screen button
              cc_load_policy: 1,    // Hide closed captions
              iv_load_policy: 3,	  // Hide video annotations
              autohide: 1           // Hide video controls when playing
            },
            events: {
              'onReady': onPlayerReady,
              'onStateChange': onPlayerStateChange
            }
          });
        }
      }
    });
  }
  
  function onPlayerReady(event) {
    event.target.playVideo();
  }
  
  function onPlayerStateChange(event) {
  }
});

// Envision - create YouTube video elements on click for slideshow heading section 
$(function() {
  if ($('.slideshow .video-element[data-id]').length) {
    $('.slideshow .video-element[data-id]').parent().find('.slideshow-button').last().on('click', function(e) {
      if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
        e.preventDefault();
        var videoID = false;
        var videoPlayerElementID = false;
        var videoElement = null;
       
        videoElement = $(this).parents('.video-container').find('.video-element[data-id]').first();
        
        if (videoElement.length) {
          videoID = videoElement.data('id');
          videoPlayerElementID = videoElement.find('.video-iframe').attr('id');
        }

        if (videoID && videoPlayerElementID) {
          var player = new YT.Player(videoPlayerElementID, {
            videoId: videoID,
            width: 560,             // Player width (in px)
            height: 316,            // Player height (in px)
            playerVars: {
              autoplay: 1,          // Auto-play the video on load
              controls: 1,          // Show pause/play buttons in player
              showinfo: 0,          // Hide the video title
              modestbranding: 1,    // Hide the Youtube Logo
              loop: 0,              // Run the video in a loop
              fs: 1,                // Hide the full screen button
              cc_load_policy: 1,    // Hide closed captions
              iv_load_policy: 3,	  // Hide video annotations
              autohide: 1           // Hide video controls when playing
            },
            events: {
              'onReady': onPlayerReady,
              'onStateChange': onPlayerStateChange
            }
          });
          
          videoElement.addClass('active');
        }
      }
    });
  }
  
  function onPlayerReady(event) {
    event.target.playVideo();
  }
  
  function onPlayerStateChange(event) {
  }
});

// Envision - create YouTube video elements on click for collection-video section 
$(function() {
  if ($('.collection-videos--section .video-element[data-id]').length) {
    $('.collection-videos--section .video-element[data-id]').on('click', function() {
      if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
        var videoID = false;
        var videoPlayerElementID = false;

        videoID = $(this).data('id');
        videoPlayerElementID = $(this).find('.video-iframe').attr('id');

        if (videoID && videoPlayerElementID) {
          var player = new YT.Player(videoPlayerElementID, {
            videoId: videoID,
            width: 560,             // Player width (in px)
            height: 316,            // Player height (in px)
            playerVars: {
              autoplay: 1,          // Auto-play the video on load
              controls: 1,          // Show pause/play buttons in player
              showinfo: 0,          // Hide the video title
              modestbranding: 1,    // Hide the Youtube Logo
              loop: 0,              // Run the video in a loop
              fs: 1,                // Hide the full screen button
              cc_load_policy: 1,    // Hide closed captions
              iv_load_policy: 3,	  // Hide video annotations
              autohide: 1           // Hide video controls when playing
            },
            events: {
              'onReady': onPlayerReady,
              'onStateChange': onPlayerStateChange
            }
          });
        }
      }
    });
  }
  
  function onPlayerReady(event) {
    event.target.playVideo();
  }
  
  function onPlayerStateChange(event) {
  }
});

// Envision - preload state field for shipping calculator on cart page
$(function() {  
  if ($('.cart-shippingcalc-form').length) {
    var stateField = $('.cart-shippingcalc-form .form-field-input[name="address[province]"]');
    
    setTimeout(function() {
      $.ajax({
        url: 'https://freegeoip.app/json/',
        method: 'GET',
        dataType: 'json',
        success: onSuccess
      });
    }, 1500);
  }
  
  function onSuccess(response) {
    $('option[value="' + response.region_name + '"]', stateField).attr('selected', true);
    stateField.trigger('change');
  }
});

// Envision - create accordion item toggles on FAQ accordion section
$(function() {  
  if ($('.faq-accordion--section').length) {
    $('.faq-accordion--section .faq-accordion--item .faq-accordion--heading-container').on('click', function(e) {
      $(this).parents('.faq-accordion--item').toggleClass('open');
    });
  }
});

// Envision - open team member popup on click 
$(function() {
  if ($('.team-profile-grid--section').length) {
    $('.team-profile-grid--section .team-member').on('click', function(e) {
      e.preventDefault();
      var popupElement = $('[data-team-profile-popup]', $(this));
      
      if (typeof lity !== undefined && popupElement.length) {
        var popup = lity(popupElement);
      }
    });
  }
});

// Envision - open popup for youtube links in product form area 
$(function() {
  if ($('.product-main').length) {
    var popupLinks = $('.product-main a[href*="youtube"]');
    if (popupLinks.length < 1) {
      popupLinks = $('.product-main a[href*="youtu.be"]');
    }
    
    $(popupLinks, '.product-main').on('click', function(e) {
      e.preventDefault();
      
      if (typeof lity !== undefined && $(this).attr('href').length) {
        var popup = lity($(this).attr('href'));
      }
    });
  }
});

// // Envision - open lightbox photo gallery on click 
// $(function() {
//   if ($('.photo-gallery--section').length) {
//     lightGallery($('#photo-gallery')[0], {
//       selector: '.photo-image',
//       subHtmlSelectorRelative: true
//     });
//   }
// });

// Envision - limit 3dcad file uploads to under 10mb
$(function() {
  if ($('.three-dee-cad-container input[type="file"]').length) {
    $('.three-dee-cad-container input[type="file"]').on('change', function(e) {
      var count=1;
      var files = e.currentTarget.files;
      var valid = true;
      
      for (var x in files) {
        var filesize = ((files[x].size/1024)/1024).toFixed(4); // MB
        if (typeof files[x].name != "undefined" && files[x].name != "item") { // limit filesize to 10mb
          if (filesize > 10) {
            valid = false;
          }
        }
      }
      
      if (!valid) {
        alert("Please select a file no larger than 10MB");
        $(this).val('');
        return false;
      }
    });
  }
});

// Envision - initialize smooth scrolling on all anchor links
$(function() {
  if (typeof SmoothScroll !== 'undefined') {
    var scroll = new SmoothScroll('a[data-smoothscroll]', {
      header: '[data-site-header-sticky]'
    });
  }
});

// Envision - dropdown navigation functionality on mobile support and blog pages
$(function() {
  if ($('select.support-nav-select').length) {
    $('select.support-nav-select').on('change', function() {
      var url = $(this).val();
      window.location.href = url;
    });
  }
  
  if ($('select.blog-nav-select').length) {
    $('select.blog-nav-select').on('change', function() {
      var url = $(this).val();
      window.location.href = url;
    });
  }
});

// Envision - extracted fitvids webpack module. 
var fitvids_webpack_module = (function(module) {
  var selectors = [
    'iframe[src*="player.vimeo.com"]',
    'iframe[src*="youtube.com"]',
    'iframe[src*="youtube-nocookie.com"]',
    'iframe[src*="kickstarter.com"][src*="video.html"]',
    "object"
  ];

  var css =
    ".fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}";

  module.exports = function(parentSelector, opts) {
    parentSelector = parentSelector || "body";
    opts = opts || {};

    if (isObject(parentSelector)) {
      opts = parentSelector;
      parentSelector = "body";
    }

    opts.ignore = opts.ignore || "";
    opts.players = opts.players || "";
    opts.ratio = opts.ratio || -1;

    var containers = queryAll(parentSelector);
    if (!hasLength(containers)) return;

    if (!document.getElementById("fit-vids-style")) {
      var head = document.head || document.getElementsByTagName("head")[0];
      head.appendChild(styles());
    }

    var custom = toSelectorArray(opts.players);
    var ignored = toSelectorArray(opts.ignore);
    var ignoredSelector = ignored.length > 0 ? ignored.join() : null;
    var selector = selectors.concat(custom).join();

    if (!hasLength(selector)) {
      return;
    }

    containers.forEach(function(container) {
      var videos = queryAll(container, selector);

      videos.forEach(function(video) {
        if (ignoredSelector && video.matches(ignoredSelector)) {
          return;
        }
        wrap(video, opts);
      });
    });
  }

  function queryAll(el, selector) {
    if (typeof el === "string") {
      selector = el;
      el = document;
    }
    return Array.prototype.slice.call(el.querySelectorAll(selector));
  }

  function toSelectorArray(input) {
    if (typeof input === "string") {
      return input
        .split(",")
        .map(trim)
        .filter(hasLength);
    } else if (isArray(input)) {
      return flatten(input.map(toSelectorArray).filter(hasLength));
    }
    return input || [];
  }

  function wrap(el, opts) {
    if (/fluid-width-video-wrapper/.test(el.parentNode.className)) {
      return;
    }

    if (opts.ratio == -1) {
      var widthAttr = parseInt(el.getAttribute("width"), 10);
      var heightAttr = parseInt(el.getAttribute("height"), 10);

      var width = !isNaN(widthAttr) ? widthAttr : el.clientWidth;
      var height = !isNaN(heightAttr) ? heightAttr : el.clientHeight;
      var aspect = height / width;
    } else {
      var aspect = opts.ratio;
    }

    el.removeAttribute("width");
    el.removeAttribute("height");

    var wrapper = document.createElement("div");
    el.parentNode.insertBefore(wrapper, el);
    wrapper.className = "fluid-width-video-wrapper";
    wrapper.style.paddingTop = aspect * 100 + "%";
    wrapper.appendChild(el);
  }

  function styles() {
    var div = document.createElement("div");
    div.innerHTML = '<p>x</p><style id="fit-vids-style">' + css + "</style>";
    return div.childNodes[1];
  }

  function hasLength(input) {
    return input.length > 0;
  }

  function trim(str) {
    return str.replace(/^\s+|\s+$/g, "");
  }

  function flatten(input) {
    return [].concat.apply([], input);
  }

  function isObject(input) {
    return Object.prototype.toString.call(input) === "[object Object]";
  }

  function isArray(input) {
    return Object.prototype.toString.call(input) === "[object Array]";
  }
});

// Envision - wrap all iframe videos on page templates contained in .rte containers
// uses fitvids module, manually pulled and adjusted from webpack source
$(function() {
  if ($('.template-page .rte iframe').length) {
    // get instance of fitvids module - main function is assigned to fitvids.exports
    var fitvids = {};
    fitvids_webpack_module(fitvids);
    
    // call fitvids exported function
    fitvids.exports('.template-page .rte', { ratio: 0.5625});
  }
});

// Envision - job name / purchase order cart inputs 
$(function() {
  if ($('.cart-purchase-order').length) {
    $('.cart-purchase-order #purchase-order').on('change', function(e) {
      if ($(this).val().trim() == '') {
        $(this).siblings('#purchase-order-value').val($(this).siblings('#purchase-order-value').data('default-value'));
      } else {
        $(this).siblings('#purchase-order-value').val($(this).val());
      }
    });
    
    $('.cart-purchase-order #purchase-order').trigger('change');
  }
});